import React from 'react';

import './Loader.scss';

export default function Loader(): JSX.Element {
  return (
    <div className="fcc">
      <div className="Loader">
        <div />
        <div />
      </div>
    </div>
  );
}
